// Finished steps fold to one line (the Record board's StepCard; Yehuda, Oct 27): the check, title,
// why, who and when, and a chevron. The current step is open. A click on the line or the chevron
// opens or folds it; when a step changes state (ticked, undone), it goes back to its default.
import type { MouseEvent } from 'react';
import { ChevronDownIcon } from '../shell/icons';

/** The chevron at the end of a step's line: the keyboard's way to open or fold it. */
export function FoldChevron({
  open,
  onToggle,
  title,
}: {
  open: boolean;
  onToggle: () => void;
  title: string;
}) {
  return (
    <button
      type="button"
      className="ibtn"
      aria-expanded={open}
      aria-label={`${open ? 'Fold' : 'Open'} ${title}`}
      onClick={(e: MouseEvent) => {
        // The line itself toggles too; one click, one toggle.
        e.stopPropagation();
        onToggle();
      }}
    >
      <ChevronDownIcon className={open ? 'ico s14 chv open' : 'ico s14 chv'} />
    </button>
  );
}
